import { render } from "./InlineMessage.vue?vue&type=template&id=31dcf884"
import script from "./InlineMessage.vue?vue&type=script&lang=js"
export * from "./InlineMessage.vue?vue&type=script&lang=js"

import "./InlineMessage.vue?vue&type=style&index=0&id=31dcf884&lang=css"
script.render = render

export default script